import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

export default class BlogCategories extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.blogCategories = app.forum.attribute('blogTags');
  }

  view() {
    return ;
  }

  // Category item
  categoryItem(tag) {
    return (
      <Link
        href={'/t/'+tag.slug()}
        className={`BlogSideWidget-item BlogSideWidget-item-${tag.id()} ${
          tag.isChild() && app.forum.attribute('blogCategoryHierarchy') == true ? 'BlogSideWidget-item-child' : ''
        }`}
      >
        <span className={tag.icon() === '' ? 'BlogSideWidget-item-colored' : ''} style={{ backgroundColor: tag.icon() === '' ? tag.color() : null }}>
          <i className={tag.icon()} />
        </span>
        {tag.name()}
      </Link>
    );
  }
}
